module.exports = __webpack_public_path__ + "img/tu01.346afd1b.jpg";